import { render, staticRenderFns } from "./global-sign-in-as.vue?vue&type=template&id=269bfc08&scoped=true&"
import script from "./global-sign-in-as.vue?vue&type=script&lang=js&"
export * from "./global-sign-in-as.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269bfc08",
  null
  
)

export default component.exports